module.exports = __webpack_public_path__ + "static/media/prb-nutri-bolsa-termica-768x591.c4c5caf7.jpg";